<template>
    <span :class="['led-dot', { 'is-off': !first, 'is-blink': blink }]" :style="dotStyle" :title="title"></span>
</template>

<script>
// 灯效预览：与 App 一致，交替闪烁 colors[0] 闪、colors[1] 为底色；interval 为 0 时常亮 colors[0]；没有颜色表示灯灭
export default {
    name: 'PairingLedDot',
    props: {
        colors: { type: Array, default: () => [] },
        interval: { type: Number, default: 0 },
        size: { type: Number, default: 14 },
    },
    computed: {
        first() {
            return (this.colors || [])[0] || ''
        },
        second() {
            return (this.colors || [])[1] || 'transparent'
        },
        blink() {
            return !!this.first && this.interval > 0
        },
        dotStyle() {
            const style = { width: `${this.size}px`, height: `${this.size}px` }
            if (!this.first) return style
            style['--led-c0'] = this.first
            style['--led-c1'] = this.second
            style.backgroundColor = this.first
            // 一个周期 = 亮 interval + 底色 interval
            if (this.blink) style['--led-duration'] = `${this.interval * 2}ms`
            return style
        },
        title() {
            if (!this.first) return '灯灭'
            if (!this.blink) return `常亮 ${this.first}`
            return `${this.first} / ${this.second}，间隔 ${this.interval}ms`
        },
    },
}
</script>

<style scoped>
.led-dot {
    display: inline-block;
    flex-shrink: 0;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    border-radius: 50%;
    vertical-align: middle;
}

.led-dot.is-off {
    border-style: dashed;
    background-color: transparent;
}

.led-dot.is-blink {
    animation: led-blink var(--led-duration) step-end infinite;
}

@keyframes led-blink {
    0% {
        background-color: var(--led-c0);
    }

    50% {
        background-color: var(--led-c1);
    }
}
</style>
